export const renewaltypes = [
    {val: 'auto', short: 'auto', long: 'This agreement renews automatically (if no notice is given)' },
    {val: 'manual', short: 'manual', long: 'This agreement requires manual notice to be renewed'},
    {val: 'none', short: 'none', long: 'This agreement does not have a renewal option'},
];